import React from 'react';

function Arrows({ arrowsHook, carouselState }) {
  const { hasArrows, hasItemsToScroll } = carouselState;
  if (!hasArrows || !hasItemsToScroll) return null;

  return (
    <>
      <PrevButton arrowsHook={arrowsHook} />
      <NextButton arrowsHook={arrowsHook} />
    </>
  );
}

export function PrevButton({ arrowsHook, children }) {
  const { onPrevButtonClick, prevBtnDisabled } = arrowsHook;

  return (
    <button
      className="mn_carouselArrow mn_prev"
      type="button"
      onClick={onPrevButtonClick}
      disabled={prevBtnDisabled}
      aria-label="previous"
    >
      {children}
    </button>
  );
}

export function NextButton({ arrowsHook, children }) {
  const { onNextButtonClick, nextBtnDisabled } = arrowsHook;

  return (
    <button
      className="mn_carouselArrow mn_next"
      type="button"
      onClick={onNextButtonClick}
      disabled={nextBtnDisabled}
      aria-label="next"
    >
      {children}
    </button>
  );
}

export default Arrows;
